<template>
    <div id="contenedor-contratistas-main"></div>
</template>

<script>
export default {
  name: 'ContratistasMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
